/**
 * 只有与页面产生交互才会触发弹窗
 */
import i18n from '@/i18n/locale';
import { secondVue } from '@/utils/secondVue';
import {
  leaveConfirmView,
  leaveConfirmClick,
} from '@/omega/business/common.js';
class Stopper {
  constructor() {
    this.open = false;
    this.tips = i18n.t('Entrega_order__hRIq');
  }
  getOpen() {
    return this.open;
  }

  setOpen(open) {
    this.open = open;
  }

  start({ tips = '' } = {}) {
    this.open = true;
    tips && (this.tips = tips);
    window.onbeforeunload = function () {
      return tips;
    };
  }

  end() {
    this.open = false;
    window.onbeforeunload = null;
  }

  routerAlert() {
    // 挽留弹窗曝光
    leaveConfirmView();
    return secondVue
      .$confirm(this.tips, i18n.t('Entrega_order__moic'), {
        confirmButtonText: i18n.t('FoodC_demand_Determination_wKQX'),
        cancelButtonText: i18n.t('FoodC_C_Cancel_Cqxt'),
      })
      .then(() => {
        // 挽留弹窗点击-确认
        leaveConfirmClick({ click_type: 1 });
        return true;
      })
      .catch(() => {
        // 挽留弹窗点击-取消
        leaveConfirmClick({ click_type: 2 });
        return false;
      });
  }
}

let stopper = new Stopper();

export default stopper;
